// extracted by mini-css-extract-plugin
export default {"badge":"BadgeTopCleaner_badge__iIj3q","badge_role":"BadgeTopCleaner_badge_role__Y7H4R"};